function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M272.34 24.11C298.08 24.11 318.95 43.33 318.95 67.03C318.95 90.74 298.08 109.95 272.34 109.95C246.6 109.95 225.74 90.74 225.74 67.03C225.74 43.33 246.6 24.11 272.34 24.11Z",
  id: "dnxFvaqN"
}), /*#__PURE__*/React.createElement("path", {
  d: "M517.62 385.44C583.63 385.44 637.14 356.49 637.14 273.6C637.14 190.7 517.62 85.24 517.62 85.24C517.62 85.24 398.1 190.7 398.1 273.6C398.1 356.49 451.61 385.44 517.62 385.44Z",
  id: "e2MLlGcy2l"
}), /*#__PURE__*/React.createElement("path", {
  d: "M520.75 303.38L469.81 217.55L520.56 292.5L520.01 261.3L484.9 199.2L519.86 253.05L519.86 253.05L518.87 196.94L481.28 147.51L518.72 188.12L518.1 85.24L521.98 221.43L521.67 215.81L559.89 161.93L522.28 226.6L525.84 289.26L525.95 287.6L570.01 230.89L526.08 293.47L526.52 301.31L526.6 301.42L526.57 302.07L535.6 461.04L523.53 461.04L522.08 378.93L478.26 316.5L521.97 372.76L520.75 303.38Z",
  id: "aSPlbJZYh"
}), /*#__PURE__*/React.createElement("path", {
  d: "M204.5 366.74C285.14 366.74 350.51 331.38 350.51 230.11C350.51 128.83 204.5 0 204.5 0C204.5 0 58.49 128.83 58.49 230.11C58.49 331.38 123.86 366.74 204.5 366.74Z",
  id: "d58BvYmkaP"
}), /*#__PURE__*/React.createElement("path", {
  d: "M208.32 266.49L146.09 161.64L208.09 253.2L207.42 215.09L164.53 139.22L207.24 205L207.24 205L206.03 136.46L160.1 76.06L205.84 125.68L205.08 0L209.83 166.38L209.44 159.52L256.14 93.69L210.19 172.69L214.54 249.24L214.67 247.21L268.5 177.94L214.83 254.39L215.38 263.96L215.48 264.1L215.43 264.89L226.47 459.1L211.72 459.1L209.95 358.79L156.41 282.52L209.82 351.25L208.32 266.49Z",
  id: "a13tVxEfiT"
}), /*#__PURE__*/React.createElement("path", {
  d: "M121.61 459.35C121.61 463.42 222.02 466.73 345.89 466.73C469.76 466.73 570.17 463.42 570.17 459.35C570.17 455.28 469.76 451.97 345.89 451.97C222.02 451.97 121.61 455.28 121.61 459.35Z",
  id: "eU8UcoqSm"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 509.98C0 514.98 46.29 519.03 103.4 519.03C160.51 519.03 206.8 514.98 206.8 509.98C206.8 504.98 160.51 500.93 103.4 500.93C46.29 500.93 0 504.98 0 509.98Z",
  id: "a44jdP0mHh"
}), /*#__PURE__*/React.createElement("path", {
  d: "M152.61 500.99C158.03 500.49 168.34 500.49 164 505.99C159.66 511.48 141.75 514.48 134.16 514.98C126.56 515.48 109.74 515.98 110.82 512.98C111.91 509.99 112.99 495.99 117.33 494.99C121.68 493.99 136.87 493.49 136.87 493.49C140.02 494.99 147.18 501.49 152.61 500.99Z",
  id: "mCWVgXh5K"
}), /*#__PURE__*/React.createElement("path", {
  d: "M90.66 496.76C96.04 497.62 105.97 500.17 100.18 504.39C94.4 508.61 76.27 507.07 68.81 505.67C61.35 504.27 45 500.59 46.92 497.97C48.84 495.35 53.97 482.14 58.44 482.25C62.91 482.36 77.69 485.64 77.69 485.64C80.29 487.87 85.29 495.9 90.66 496.76Z",
  id: "b6S8IVgmo"
}), /*#__PURE__*/React.createElement("path", {
  d: "M148.27 391.04C146.64 399.04 145.55 411.53 145.55 411.53C145.55 411.53 146.64 422.03 145.55 427.03C144.47 432.02 137.95 479.5 137.95 480.5C137.95 481.5 139.04 484.5 137.95 487C136.87 489.5 134.7 487.5 137.95 491.49C141.21 495.49 139.04 496.49 138.5 496.49C137.95 496.49 116.79 498.49 115.71 496.49C114.62 494.49 116.25 493.99 115.71 491.49C115.16 489 114.62 488.5 113.54 488C112.45 487.5 110.28 488.5 111.91 486C113.54 483.5 117.33 480.5 116.25 479C115.16 477.5 116.79 466.51 116.79 466.51C116.79 466.51 117.88 442.02 118.42 427.03C118.96 412.03 113.54 396.54 113.54 396.54C112.86 408.81 107.91 420.55 99.43 430.02C85.32 445.52 78.26 474.5 78.26 474.5C78.26 474.5 75.01 479 76.64 483C78.26 487 83.15 484.5 78.26 487C73.38 489.5 56.56 486 54.93 484.5C53.3 483 57.1 481 56.01 477C54.93 473 50.59 474 54.39 472C58.18 470 59.27 470.5 59.27 468.51C59.27 466.51 69.04 423.03 84.23 410.53C84.34 405.99 85.21 369.6 85.32 365.06C85.32 365.06 71.75 333.07 85.86 330.07C99.97 327.07 142.91 339 142.91 339C143.98 349.41 149.89 383.05 148.27 391.04Z",
  id: "a3kAfFpgpr"
}), /*#__PURE__*/React.createElement("path", {
  d: "M126.02 244.61C128.19 247.61 99.43 234.62 99.43 234.62C99.43 234.62 108.65 213.63 108.65 211.13C108.65 208.63 133.07 220.63 133.07 220.63C131.66 225.42 123.85 241.62 126.02 244.61Z",
  id: "b1S1Sw8y3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M126.29 188.89C137.38 188.89 146.37 197.17 146.37 207.38C146.37 217.59 137.38 225.87 126.29 225.87C115.2 225.87 106.21 217.59 106.21 207.38C106.21 197.17 115.2 188.89 126.29 188.89Z",
  id: "bOSXmdI8h"
}), /*#__PURE__*/React.createElement("path", {
  d: "M120.59 232.62C127.64 240.62 128.73 242.61 128.73 242.61C128.73 242.61 145.55 267.6 142.3 280.1C141.5 281.22 140.78 282.39 140.13 283.6C139.04 285.59 139.04 313.58 140.13 318.08C141.21 322.58 142.3 324.08 141.21 330.57C140.13 337.07 149.89 347.56 138.5 349.56C127.1 351.56 118.42 350.06 114.62 345.57C110.82 341.07 114.08 338.07 102.14 338.07C90.2 338.07 82.6 330.57 82.6 330.57C82.6 330.57 88.57 324.58 86.4 323.58C84.23 322.58 86.4 320.08 87.49 317.58C88.57 315.08 88.57 313.08 86.95 313.08C85.32 313.08 86.4 312.08 87.49 309.58C88.57 307.08 68.5 264.1 80.43 251.61C92.37 239.12 98.34 232.12 98.34 232.12C98.34 232.12 96.17 224.62 99.43 226.12C103.66 227.42 113.54 224.62 120.59 232.62Z",
  id: "a2tiFl2Sac"
}), /*#__PURE__*/React.createElement("path", {
  d: "M130.36 295.59C140.78 327.37 146.57 345.03 147.72 348.56C147.72 348.56 159.12 376.05 147.72 376.05C136.33 376.05 136.94 349.82 136.94 349.82C134.49 345.84 114.9 314.06 112.45 310.08C112.45 310.08 102.68 278.6 103.77 276.1C104.85 273.6 130.36 273.6 130.36 273.6C130.36 276.53 130.36 283.86 130.36 295.59Z",
  id: "ay1nJL"
}), /*#__PURE__*/React.createElement("path", {
  d: "M133.14 193.5C135.69 194.33 138.52 193.93 140.67 192.42C142.71 190.87 143.58 188.01 142.38 185.83C141.34 183.95 139.12 182.92 136.99 182.15C132.29 180.46 127.33 179.43 122.3 179.1C119.9 178.94 117.38 178.97 115.23 179.98C114.17 180.48 113.25 181.2 112.2 181.72C110.27 182.67 108.03 182.88 105.94 183.49C101.62 184.79 98.13 187.75 96.36 191.6C95.79 192.9 95.4 194.25 95.18 195.63C94.56 199.41 94.99 203.27 96.45 206.85C98.76 212.52 103.61 217.48 103.89 223.54C106.86 221.55 107.96 217.97 110.34 215.4C112.11 213.5 114.53 212.21 117.2 211.74C117.94 211.69 118.65 211.46 119.24 211.05C119.65 210.59 119.91 210.04 119.99 209.45C120.19 208.56 121.82 201.49 122.02 200.61C122.43 198.81 122.95 196.85 124.56 195.76C125.56 195.17 126.69 194.8 127.87 194.68C130.67 194.23 133.51 194 136.35 193.97",
  id: "f5nD2cffwH"
}), /*#__PURE__*/React.createElement("path", {
  d: "M133.07 263.1C128.73 279.1 133.07 278.6 133.07 278.6C133.07 278.6 110.82 276.6 103.77 281.1C103.61 280.5 102.3 275.7 102.14 275.1C102.14 275.1 95.63 240.62 121.13 241.12C123.52 245.51 137.41 247.11 133.07 263.1Z",
  id: "f6CiYQn9PZ"
}), /*#__PURE__*/React.createElement("path", {
  d: "M376.47 232.68C376.47 232.68 376.47 232.68 376.47 232.68C376.47 368.68 376.47 444.24 376.47 459.35C376.47 459.35 376.47 459.35 376.47 459.35C392.2 459.35 400.94 459.35 402.69 459.35C402.69 459.35 402.69 459.35 402.69 459.35C402.69 323.35 402.69 247.79 402.69 232.68C402.69 232.68 402.69 232.68 402.69 232.68C386.96 232.68 378.22 232.68 376.47 232.68Z",
  id: "b2Vee2T7vI"
}), /*#__PURE__*/React.createElement("path", {
  d: "M430.36 284.32L430.36 242.74L269.43 242.74L222.82 263.53L269.43 284.32L430.36 284.32Z",
  id: "b2ZSbZHQRR"
}), /*#__PURE__*/React.createElement("path", {
  d: "M430.36 280.96L430.36 284.32L269.43 284.32L222.82 263.53L226.58 261.85L269.43 280.96L430.36 280.96Z",
  id: "anOsCALs9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M348.07 339.31L348.07 297.73L509 297.73L555.61 318.52L509 339.31L348.07 339.31Z",
  id: "c6cgb3bIXf"
}), /*#__PURE__*/React.createElement("path", {
  d: "M555.61 318.52L509 339.31L348.07 339.31L348.07 335.95L509 335.95L551.85 316.84L555.61 318.52Z",
  id: "a1glBMHUX1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M312.39 250.79C312.39 250.79 312.39 250.79 312.39 250.79C312.39 266.08 312.39 274.57 312.39 276.27C312.39 276.27 312.39 276.27 312.39 276.27C328.99 276.27 338.22 276.27 340.06 276.27C340.06 276.27 340.06 276.27 340.06 276.27C340.06 260.98 340.06 252.48 340.06 250.79C340.06 250.79 340.06 250.79 340.06 250.79C323.46 250.79 314.24 250.79 312.39 250.79Z",
  id: "cq9sABV1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M451.47 305.78C459.12 305.78 465.31 311.48 465.31 318.52C465.31 325.56 459.12 331.26 451.47 331.26C443.83 331.26 437.64 325.56 437.64 318.52C437.64 311.48 443.83 305.78 451.47 305.78Z",
  id: "ceMud8ew0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M389.58 254.81C394 254.81 397.59 258.11 397.59 262.19C397.59 266.26 394 269.56 389.58 269.56C385.16 269.56 381.57 266.26 381.57 262.19C381.57 258.11 385.16 254.81 389.58 254.81Z",
  id: "a1htbnXmZn"
}), /*#__PURE__*/React.createElement("path", {
  d: "M389.58 309.8C394 309.8 397.59 313.1 397.59 317.18C397.59 321.25 394 324.55 389.58 324.55C385.16 324.55 381.57 321.25 381.57 317.18C381.57 313.1 385.16 309.8 389.58 309.8Z",
  id: "bI4kW9EcY"
}), /*#__PURE__*/React.createElement("path", {
  d: "M450.63 454.42C450.9 454.42 451.18 454.42 451.46 454.41C452.01 454.4 452.56 454.38 453.11 454.34C463.94 453.64 472.35 448.1 472.35 434.09C472.35 419.59 452.23 401.29 450.72 399.93C450.72 399.93 450.71 399.93 450.71 399.93C450.65 399.88 450.63 399.85 450.63 399.85C450.63 399.85 428.9 419.02 428.9 434.09C428.9 449.16 438.63 454.42 450.63 454.42Z",
  id: "f8ZwAf6KH"
}), /*#__PURE__*/React.createElement("path", {
  d: "M443.47 441.89L451.44 453.24C451.45 453.94 451.46 454.33 451.46 454.41C452.01 454.4 452.56 454.38 453.11 454.34C453.05 453.34 452.77 448.31 452.25 439.27L452.26 439.15L452.24 439.13L452.16 437.7L460.15 426.33L452.14 436.64L452.12 436.94L451.47 425.55L458.31 413.79L451.39 423.55L450.72 399.93L450.71 399.85L450.71 399.93L450.83 418.55L444.02 411.17L450.85 420.16L451.03 430.36L444.68 420.57L451.06 431.86L451.16 437.53L441.93 423.9L451.19 439.5L451.42 452.12L443.47 441.89Z",
  id: "a1GCsooojT"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#dnxFvaqN",
  opacity: 1,
  fill: "#2a9f8b",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#dnxFvaqN",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#000000",
  strokeWidth: 1,
  strokeOpacity: 0
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#e2MLlGcy2l",
  opacity: 1,
  fill: "#a4d9cf",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#e2MLlGcy2l",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#000000",
  strokeWidth: 1,
  strokeOpacity: 0
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#aSPlbJZYh",
  opacity: 1,
  fill: "#3f3d56",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#aSPlbJZYh",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#000000",
  strokeWidth: 1,
  strokeOpacity: 0
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#d58BvYmkaP",
  opacity: 1,
  fill: "#a4d9cf",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#d58BvYmkaP",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#000000",
  strokeWidth: 1,
  strokeOpacity: 0
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a13tVxEfiT",
  opacity: 1,
  fill: "#3f3d56",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a13tVxEfiT",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#000000",
  strokeWidth: 1,
  strokeOpacity: 0
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#eU8UcoqSm",
  opacity: 1,
  fill: "#3f3d56",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#eU8UcoqSm",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#000000",
  strokeWidth: 1,
  strokeOpacity: 0
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a44jdP0mHh",
  opacity: 1,
  fill: "#3f3d56",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a44jdP0mHh",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#000000",
  strokeWidth: 1,
  strokeOpacity: 0
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#mCWVgXh5K",
  opacity: 1,
  fill: "#575a89",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#mCWVgXh5K",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#000000",
  strokeWidth: 1,
  strokeOpacity: 0
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#b6S8IVgmo",
  opacity: 1,
  fill: "#575a89",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#b6S8IVgmo",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#000000",
  strokeWidth: 1,
  strokeOpacity: 0
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a3kAfFpgpr",
  opacity: 1,
  fill: "#2f2e41",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a3kAfFpgpr",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#000000",
  strokeWidth: 1,
  strokeOpacity: 0
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#b1S1Sw8y3",
  opacity: 1,
  fill: "#a0616a",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#b1S1Sw8y3",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#000000",
  strokeWidth: 1,
  strokeOpacity: 0
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#bOSXmdI8h",
  opacity: 1,
  fill: "#a0616a",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#bOSXmdI8h",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#000000",
  strokeWidth: 1,
  strokeOpacity: 0
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a2tiFl2Sac",
  opacity: 1,
  fill: "#27bba1",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a2tiFl2Sac",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#000000",
  strokeWidth: 1,
  strokeOpacity: 0
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#ay1nJL",
  opacity: 1,
  fill: "#a0616a",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#ay1nJL",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#000000",
  strokeWidth: 1,
  strokeOpacity: 0
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#f5nD2cffwH",
  opacity: 1,
  fill: "#2f2e41",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#f5nD2cffwH",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#000000",
  strokeWidth: 1,
  strokeOpacity: 0
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#f6CiYQn9PZ",
  opacity: 1,
  fill: "#27bba1",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#f6CiYQn9PZ",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#000000",
  strokeWidth: 1,
  strokeOpacity: 0
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#b2Vee2T7vI",
  opacity: 1,
  fill: "#2f2e41",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#b2Vee2T7vI",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#000000",
  strokeWidth: 1,
  strokeOpacity: 0
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#b2ZSbZHQRR",
  opacity: 1,
  fill: "#3f3d56",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#b2ZSbZHQRR",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#000000",
  strokeWidth: 1,
  strokeOpacity: 0
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#anOsCALs9",
  opacity: 1,
  fill: "#000000",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#anOsCALs9",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#000000",
  strokeWidth: 1,
  strokeOpacity: 0
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#c6cgb3bIXf",
  opacity: 1,
  fill: "#3f3d56",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#c6cgb3bIXf",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#000000",
  strokeWidth: 1,
  strokeOpacity: 0
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a1glBMHUX1",
  opacity: 1,
  fill: "#000000",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a1glBMHUX1",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#000000",
  strokeWidth: 1,
  strokeOpacity: 0
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#cq9sABV1",
  opacity: 1,
  fill: "#27bba1",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#cq9sABV1",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#000000",
  strokeWidth: 1,
  strokeOpacity: 0
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#ceMud8ew0",
  opacity: 1,
  fill: "#27bba1",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#ceMud8ew0",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#000000",
  strokeWidth: 1,
  strokeOpacity: 0
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a1htbnXmZn",
  opacity: 1,
  fill: "#2f2e41",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a1htbnXmZn",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#000000",
  strokeWidth: 1,
  strokeOpacity: 0
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#bI4kW9EcY",
  opacity: 1,
  fill: "#2f2e41",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#bI4kW9EcY",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#000000",
  strokeWidth: 1,
  strokeOpacity: 0
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#f8ZwAf6KH",
  opacity: 1,
  fill: "#27bba1",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#f8ZwAf6KH",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#000000",
  strokeWidth: 1,
  strokeOpacity: 0
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a1GCsooojT",
  opacity: 1,
  fill: "#3f3d56",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a1GCsooojT",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#000000",
  strokeWidth: 1,
  strokeOpacity: 0
})))));

var SvgLost = function SvgLost(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 640 640",
    width: 1600,
    height: 1600,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLost, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lost.87f46212.svg";
export { ForwardRef as ReactComponent };